import Layout from '../components/layout/index.vue';
import LayoutOld from '../components/layout/index-for-old.vue';
import baseInfo from './base-info/index.route';
import system from './system/index.route';
import dataMaidian from './data/index.route';
import platform from './platform-account-management/index.route';
import operate from './operate/index.route';
import source from './source/index.route';
import HelloWorld from "./demo.vue";
import brand from './brand/index.route';
import applet from './applet/index.route';
import zhaopin from './zhaopin/index.route';
import mall from './mall/index.route';
import packageRoute from './package/index.route';

export default [{
  path: '/',
  name: 'Layout',
  component: process.env.HOST == 'old' ? LayoutOld : Layout,
  redirect: '/index',
  children: [...baseInfo, ...system, ...dataMaidian, ...platform, ...operate, ...source, ...brand, ...applet, ...zhaopin, ...mall, ...packageRoute, {
    path: '/demo',
    component: HelloWorld
  }],
}];



// WEBPACK FOOTER //
// ./src/views/view.route.js